import { __module as interopRequireWildcard } from '../../../../_virtual/interopRequireWildcard.js';
import './typeof.js';
import { exports as _typeofExports } from '../../../../_virtual/typeof.js';

(function (module) {
	var _typeof = _typeofExports["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (interopRequireWildcard));
//# sourceMappingURL=interopRequireWildcard.js.map
